import React from 'react';
import "primeicons/primeicons.css";
import 'primereact/resources/primereact.min.css';
import { FormSectionElements, FormSubSections, ProgramContainer } from '../entities/formTemplateDataType';
import Utils from '../utilities/Utils';
import XMLParser from '../utilities/XMLParser';
import {ElementListComponent} from './ElementListComponent';
import axios from 'axios';
import URLUtils from '../utilities/URLUtils';
import {FileUpload} from 'primereact/fileupload';
import '../../public/assets/css/App.css';
import {Button, Column, DataTable, InputText} from 'primereact';
import classNames from 'classnames';
import {User} from '../entities/User';
import * as XLSX from 'xlsx';
import {InformationalAlertComponent} from './odsCalloutBox/InformationalAlertComponent';
import {InformationalRichTextComponent} from './odsCalloutBox/InformationalRichTextComponent';
import {WarningAlertComponent} from './odsCalloutBox/WarningAlertComponent';
import {SuccessAlertComponent} from './odsCalloutBox/SuccessAlertComponent';
import FadeableWrapper from './odsCalloutBox/FadeableWrapper';
import {HintExpansionComponent} from './odsCalloutBox/HintExpansionComponent';
import {ErrorAlertComponent} from './odsCalloutBox/ErrorAlertComponent';
import {GeneralCalloutComponent} from './odsCalloutBox/GeneralCalloutComponent';
import {DateComponent} from './subComponent/DateComponent';
import {OdsDateComponent} from './subComponent/OdsDateComponent';
import {OdsDateRangeComponent} from './subComponent/OdsDateRangeComponent';
import {PostalCodeComponent} from './subComponent/PostalCodeComponent';
import {EmailComponent} from './subComponent/EmailComponent';
import {TextComponent} from './subComponent/TextComponent';
import {MultiTextComponent} from './subComponent/MultiTextComponent';
import {AutoCompleteComponent} from './subComponent/AutoCompleteComponent';
import {DropdownComponent} from './subComponent/DropdownComponent';
import {CheckboxComponent} from './subComponent/CheckboxComponent';
import {DriverLicenseComponent} from './subComponent/DriverLicenseComponent';
import {GroupDropdownComponent} from './subComponent/GroupDropdownComponent';
import {NumberComponent} from './subComponent/NumberComponent';
import {PhoneComponent} from './subComponent/PhoneComponent';
import {CurrencyComponent} from './subComponent/CurrencyComponent';
import {LicensePlateComponent} from './subComponent/LicensePlateComponent';
import {HealthCardComponent} from './subComponent/HealthCardComponent';
import {ButtonComponent} from './subComponent/ButtonComponent';
import {BusinessNumberComponent} from './subComponent/BusinessNumberComponent';
import {DateTimeComponent} from './subComponent/DateTimeComponent';
import {GoogleLookUpAddressComponent} from './subComponent/GoogleLookUpAddressComponent';
import {MultipleCheckboxComponent} from './subComponent/MultipleCheckboxComponent';
import {CheckboxWithTextboxComponent} from './subComponent/CheckboxWithTextboxComponent';
import {RadioButtonComponent} from './subComponent/RadioButtonComponent';
import {SelectWithRichTextComponent} from './subComponent/SelectWithRichTextComponent';
import {RichTextComponent} from './subComponent/RichTextComponent';
import {AddressComponent} from './subComponent/AddressComponent';
import {RowComponent} from './subComponent/RowComponent';
import {EmailButtonComponent} from './subComponent/EmailButtonComponent';
import {TableComponent} from './subComponent/TableComponent';
import {HiddenFieldComponent} from './subComponent/HiddenFieldComponent';
import {CheckboxWithInlineTextboxComponent} from './subComponent/CheckboxWithInlineTextboxComponent';
import {displayField, getRootComponent, isBxpForm} from '../utilities/ElementUtils';
import AccordionsComponent from '../commonComponent/AccordionsComponent';
import FileUploadComponent from './subComponent/FileUploadComponent';
import FeedbackComponent from './subComponent/FeedbackComponent';
import {TechErrorComponent} from './subComponent/TechErrorComponent';
import StartRatingAccessibilityComponent from './subComponent/StarRatingAccessibilityComponent';
import TransactionIdComponent from './subComponent/TransactionIdComponent';
import {RepeatButtonComponent} from './subComponent/RepeatButtonComponent';
import {EmailConfirmationComponent} from './subComponent/EmailConfirmationComponent';
import {PublicSecureButtonComponent} from './subComponent/PublicSecureButtonComponent';
import {DataTableComponent} from './subComponent/DataTableComponent';
import {ReportDataTable} from './subComponent/ReportDataTable';
import {TableMenuComponent} from './subComponent/TableMenuComponent';
import {CustomErrorAlertsComponent} from './subComponent/CustomErrorAlertsComponent';
import {SubmitButtonComponent} from './subComponent/SubmitButtonComponent';
import SummaryListComponent from './subComponent/SummaryListComponent';
import PagedSummaryListComponent from './subComponent/PagedSummaryListComponent';
import TableSummaryElementComponent from './subComponent/TableSummaryElementComponent';
import {CMAQuestionComponent} from './subComponent/cma/CMAQuestionComponent';
import {parseJson, stringifyJson} from '../utilities/JsonUtils';
import {RegistrantIdenticationNumberComponent} from './subComponent/RegistrantIdentificationNumberComponent';
import {SearchAutocompleteComponent} from './subComponent/SearchAutocompleteComponent';
import CheckPlateAndRenderImageComponent from './subComponent/CheckPlateAndRenderImageComponent';
import {RadioWithRichTextComponent} from './subComponent/RadioWithRichTextComponent';
import {InquireAndRedirectComponent} from './subComponent/InquireAndRedirectComponent';
import OrderConfirmationComponent from './subComponent/OrderConfirmationComponent';
import IncidentReportConfirmationComponent from './subComponent/IncidentReportConfirmationComponent';
import OrderPriceBreakdownComponent from './subComponent/OrderPriceBreakdownComponent';
import {calloutWidths} from "../entities/Constants";
import CardComponent from './subComponent/CardComponent';
import UnorderList from './subComponent/UnorderedList';
import GoogleMapComponent from './subComponent/GoogleMapComponent';
import SignaturePadComponent from './subComponent/SignaturePadComponent';
import DeleteSubsectionButtonComponent from './subComponent/DeleteSubsectionButtonComponent';
import {BXPCheckboxWithInlineTextboxComponent} from './subComponent/bxp/BXPCheckboxWithInlineTextboxComponent';
import { TimeComponent } from './subComponent/TimeComponent';
import PdfButtonComponent from '../designComponent/subComponent/PdfButtonComponent';
import DynamicAccordionFormComponent from './subComponent/DynamicAccordionFormComponent';
import SearchSingleItemFromApiComponent from './subComponent/SearchSingleItemFromApiComponent';
import TileSelectionComponent from '../commonComponent/TileSelectionComponent';
import SessionStorageService from '../services/SessionStorageService';
import { BXPCancelWithExitComponent } from './subComponent/bxp/BXPCancelWithExitCompnent';
import OrderBreakdownComponent from './subComponent/order/OrderBreakdownComponent';
import OrderInfoBreakdownComponent from './subComponent/order/OrderInfoBreakdownComponent';
import { ModalComponent } from './subComponent/ModalComponent';
import FieldModalComponent from './subComponent/FieldModalComponent';
import { fi } from 'date-fns/locale';
import { get } from 'jquery';


interface Props {
  isEng: boolean;
  field: FormSectionElements;
  editable: boolean;
  roleBasedEditable?: boolean;
  optionsFieldValue?:Map<string,string>;
  user?: User;
  callbackElement: (programContainer: ProgramContainer)=> void;
  topEntity?;
  roleBased?: boolean;
  usedForFilter?: boolean;
  ownerEditableOnly?: boolean;
  UseAsterisks?,
  HideOptionalText?,
  returnIndex?:number;
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
  callbackValidate?: (errors:any, fromAPI?:boolean)=>void;
  onBusyChange?: (isBusy: boolean) => void;
  callbackGeneratePdf?: (field: FormSectionElements) => void;
}

interface State {
  // activeObject: FormSectionElements;
  // editable: boolean;
  // callbackElement;
  // user: User;
  // topEntity;
 // suggestions;
  touched: boolean
  attContent: any
}

var fieldIds = [];

export class ElementComponent extends React.Component<Props, State> {
  subSection: FormSubSections;
  attachmentContent = [];
  worksheetNames = [];
  fileUploaded = false;
  toast;
  HtmlToReactParser = require('html-to-react').Parser;

  readonly TOTAL_COLUMN_VALUE = "Totals:"

  constructor(props: Props) {
    super(props);
   
    // this.props.field.DisplayedInScreen = true;
    this.state = {
      //   activeObject: this.props.field,
      //   editable: this.props.editable,
      //   callbackElement: this.props.callbackElement,
      //   user: this.props.user,
      //   topEntity: this.props.topEntity,
      touched: false,
      attContent: []
    };

 
  }

  componentWillUnmount() {
    console.log("!!!!!!! ElementComponent is being REMOVED from the DOM !!!");
    console.trace(); 
  }

  onTextEditChange = (e) => {
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    this.props.field.Valid = Utils.isNotNullOrEmpty(val);
    this.props.field.Value = val;
    // this.setState({ activeObject: this.props.field });
    this.props.callbackElement(getRootComponent(this.props.field));
  }


  render() {
    //  const programContainer = getRootComponent(this.props.field);
    return this.generateFieldControl(this.props.field);
  }

  valueLength(value) {
    if (typeof value == 'string') {
      return value.length;
    }
    return 0;
  }

  generateFieldControl = (field: FormSectionElements) => {
    const programContainer = getRootComponent(this.props.field);
    var controlArray = [];
 
    var title = this.props.isEng ?field.ENUTitle: field.FRATitle;
    if (title === '.') {
      title = '';
    }

    var editable = field.Editable === 'Y' && this.props.editable;
    let parentSub = field.parent as FormSubSections;

    //let subEditable = parentSub.ListOfFormSectionElements?.filter(p => p.Editable === 'Y').length > 0 && this.props.editable;
    var requiredField = field.Optional !== 'Y';
    if (field.Datatype === 'Address' && field.AlwaysDisplayCity && field.AlwaysDisplayProvince) {
        requiredField = false;
    }
    let labelControlArray = [];
   
    const htmlToReactParser = new this.HtmlToReactParser();
    if (field.richTextChecked && Utils.isNotNullOrEmpty(title)) {
        title = title.replace(
            /<\/?(div|p|h[1-6]|ul|ol|li|table|tr|td|th|thead|tbody|tfoot|br)>/gi,
            ""
        );
        title = htmlToReactParser.parse(title);
    }
    const reactElement =
        field.MessageBody != null
            ? htmlToReactParser.parse(
                this.props.isEng ? field.MessageBody : field.MessageBodyFRA
            )
            : null;
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;
    let hint;
    if (field.Hint || field.HintFR) {
        const match = hintHtml?.match(/^<p>([\s\S]*?)<\/p>$/i);
        if (match) {
            hintHtml = match[1];
        }
        hint = htmlToReactParser.parse(hintHtml);
    }

    // controlArray.push(<div style={{ alignContent: 'center', alignItems: 'center', width:'100%' }}>{reactElement}</div>);
    const requireLabel=this.props.isEng? "(required)":"(obligatoire)";
    if (requiredField === true) {
      labelControlArray.push(
        <div key={'fdLbl_' + field.Id} className="ontario-margin-top-24-!" >
          {title &&(
            // <label aria-label={title + ' required'} htmlFor={field.LoadBindName} className="ontario-label" >
            <label htmlFor={field.LoadBindName} className="ontario-label" style={{...(getRootComponent(field).ErrorBottom && { marginBottom: '4px' }), ...(field?.fieldSize && { fontSize: field?.fieldSize }) }} key={'fdLbl_' + field.Id} >
              {title}<span className="ontario-label__flag">{this.props.UseAsterisks=="Y"?<span style={{color:'red'}}>*</span>:<span className='ontario-label__flag'>{requireLabel}</span>}
              </span>
              {field.TooltipENU && (<i role='tooltip' title={field.TooltipENU} className="pi pi-info-circle"></i>)}
            </label>
          )}

            {hintHtml ? <p className="ontario-hint" id={`hint-text-${field.LoadBindName}`} tabIndex={field.Valid ? undefined : -1} style={field?.fieldHintSize ? { fontSize: field?.fieldHintSize } : undefined} dangerouslySetInnerHTML={{ __html: hintHtml }}></p> : null}
        </div>);
    } else {
      labelControlArray.push(
        <div key={'fdLbl_' + field.Id} className="ontario-margin-top-24-!">

          <label htmlFor={field.LoadBindName}  className="ontario-label"  style={{...(getRootComponent(field).ErrorBottom && { marginBottom: '4px' }), ...(field?.fieldSize && { fontSize: field?.fieldSize }) }} key={'fdLbl_' + field.Id}>{title} <span className="ontario-label__flag">{!this.props.field.ReadOnly && this.props.HideOptionalText != "Y" && (this.props.UseAsterisks=="Y"? '' : this.props.isEng ?"(optional)": "(facultatif)") }</span>

            {field.enuToolTip ? <i title={field.TooltipENU} className="pi pi-info-circle"></i> : null}
          </label>
            {hintHtml ? <p className="ontario-hint" id={`hint-text-${field.LoadBindName}`} tabIndex={field.Valid ? undefined : -1} style={field?.fieldHintSize ? { fontSize: field?.fieldHintSize } : undefined} dangerouslySetInnerHTML={{ __html: hintHtml }}></p> : null}
        </div>);
    }  

    let labelForRadioRichText = [];
    const requiredLabel = this.props.field.Optional == "N" ? this.props.isEng   ? "(required)"   : "(obligatoire)" : this.props.HideOptionalText == "Y" ? "" : this.props.isEng ? "(optional)" : "(facultatif)"
    labelForRadioRichText.push(
      <div key={'fdLbl_' + field.Id}  >
        <legend className="ontario-fieldset__legend" id={`label_${field.LoadBindName}`} key={'fdLbl_' + field.Id} >
            {title}
            <span className='ontario-label__flag'>
                {title ? requiredLabel : null}
            </span>{" "}
            {field.TooltipENU && (<i role='tooltip' title={field.TooltipENU} className="pi pi-info-circle"></i>)}
        </legend>
            {hintHtml ? <p className="ontario-hint" id={`hint-text-${field.LoadBindName}`} tabIndex={field.Valid ? undefined : -1} style={field?.fieldHintSize ? { fontSize: field?.fieldHintSize } : undefined} dangerouslySetInnerHTML={{ __html: hintHtml }}></p> : null}
        </div>
     )
    // }
    let displayfield: boolean = true;

    const setFieldValue = (value: any) => {
      field.Value = value;
      const programContainer = getRootComponent(field);
      this.props.callbackElement(programContainer);
    };
 
    switch (field.Datatype) {
      case 'RadioButton':
        displayfield = displayField(field);
        if (displayfield) {
          controlArray.push(
              <RadioButtonComponent key={"RadioButtonComponent_" + field.parent.Id + "_" + field.Id}
              field={this.props.field}
              editable={editable} title={title} 
              labelControlArray={labelControlArray}
              requiredField={requiredField} 
              Visible={field.Visible}
              isEng={this.props.isEng}
              onBusyChange={isbusy=>this.props.onBusyChange(isbusy)}
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}
            />) 
        }
        field.Visible = displayfield;
        break;
      case 'Row':
        controlArray.push(
          <RowComponent
          key={"RowComponent_" + field.Id} 
          isEng={this.props.isEng}
          field={this.props.field}
          editable={this.props.editable}
          roleBasedEditable={this.props.roleBasedEditable}
          optionsFieldValue={this.props.optionsFieldValue}
          user={this.props.user}
          //topEntity={this.props.topEntity}
          roleBased={this.props.roleBased}
          //usedForFilter={false}
          ownerEditableOnly={this.props.ownerEditableOnly}
          UseAsterisks={this.props.UseAsterisks}
          returnIndex={this.props.returnIndex}
          callbackValidate={(errors)=>this.props.callbackValidate(errors)}
          callbackStepIndex={(index,returnIndex)=>this.props.callbackStepIndex(index, returnIndex)}
          callbackGeneratePdf={this.props.callbackGeneratePdf}
          title={title} labelControlArray={labelControlArray} 
          callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}
          >
          </RowComponent>
        );
        break;

      case 'CheckGroup':
        controlArray.push(<MultipleCheckboxComponent key={"MultipleCheckboxComponent" + field.Id} field={this.props.field} editable={editable} title={title} 
          optionsFieldValue={this.props.optionsFieldValue} labelControlArray={labelControlArray} requiredField={requiredField} isEng={this.props.isEng}
    onBusyChange={isbusy=>this.props.onBusyChange(isbusy)}    callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>

        </MultipleCheckboxComponent>);
        break;
      case 'Date':
        controlArray.push(
          <DateComponent key={"DateComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField} isEng={this.props.isEng}
          callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>

          </DateComponent>);

        break;
      case 'Card':
        controlArray.push(
          <CardComponent key={"CardComponent" + field.Id} field={this.props.field} isEng={this.props.isEng}
            callbackStepIndex={(index, returnIndex) => this.props.callbackStepIndex(index, returnIndex)}
            callbackElement={(programContainer: ProgramContainer) => { this.props.callbackElement(programContainer) }}>
          </CardComponent>);
        break;
      case 'DateTime':
          controlArray.push(
            <DateTimeComponent key={"DateTimeComponent" + field.Id}  field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </DateTimeComponent>);
  
          break;
      case 'Time':
          controlArray.push(
            <TimeComponent key={"TimeComponent" + field.Id}  field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </TimeComponent>);
  
          break;         
      case 'ODSDate':
        controlArray.push(
          <OdsDateComponent key={"OdsDateComponent" + field.Id}  
            field={this.props.field} editable={editable} title={title} 
            labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng} hint={hint} useAsterisks={this.props.UseAsterisks}
            HideOptionalText={this.props.HideOptionalText}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </OdsDateComponent>);

        break;
      case 'ODSDateRange':
        controlArray.push(
          <OdsDateRangeComponent key={"OdsDateRangeComponent" + field.Id}  
            field={this.props.field} editable={editable} title={title} 
            labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng} hint={hint} useAsterisks={this.props.UseAsterisks}
            HideOptionalText={this.props.HideOptionalText}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </OdsDateRangeComponent>);

        break;
      case 'PostalCode':
           controlArray.push(
            <PostalCodeComponent key={"PostalCodeComponent" + field.Id}  field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </PostalCodeComponent>
           );
        break;
      case 'Currency':
        controlArray.push(
          <CurrencyComponent key={"CurrencyComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </CurrencyComponent>
         );
        break;
      case 'Percentage':
        if (editable) {
          controlArray.push(
            <div key={'fd_' + field.Id}  >
              <div key={'fdLbl_div_' + field.Id} >
                {labelControlArray}
              </div>
              <div key={'fdIpt_div_' + field.Id} style={{ display: 'flex', marginBottom: '30px', verticalAlign: 'middle' }}>
                <span className="p-input-icon-left">
                  <i className="pi pi-percentage" />
                  <InputText className="ontario-input" style={{ width: "90%", textAlign: 'right' }} keyfilter="num" id={'fdIpt_' + field.Id} key={'fdIpt_' + field.Id} required={requiredField} value={field.Value} readOnly={field.ReadOnly} onChange={this.onTextEditChange} />
                </span>
              </div>
            </div>);
        } else {
          controlArray.push(
            <div key={'fdIpt_div_invalid_' + field.Id} className={classNames(programContainer.isHorizontalLayout ? 'pdf-row-column' : 'pdf-two-column',
              { 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField }
            )}
            >
              <div>{title}</div>
              <div> {field.Value}</div>
            </div>
          );
        }
        break;
      case 'PhoneNumber':
        controlArray.push(
          <PhoneComponent key={"PhoneComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}   callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </PhoneComponent>
        );
        break;
      case 'BusinessNumber':
          controlArray.push(
            <BusinessNumberComponent key={"BusinessNumberComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </BusinessNumberComponent>
          )
          break;   
        case 'Email':
          controlArray.push(
            <EmailComponent  key={"EmailComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
                callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </EmailComponent>
          );
          break;
        case 'EmailConfirmation':
            controlArray.push(
              <EmailConfirmationComponent  key={"EmailConfirmationComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
              isEng={this.props.isEng}
                  callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
              </EmailConfirmationComponent>
            );
        break;
        case 'EmailButton':
          controlArray.push(
            <EmailButtonComponent  key={"EmailComponent" + field.Id} field={this.props.field} editable={editable} title={title} 
                labelControlArray={labelControlArray} requiredField={requiredField}
                isEng={this.props.isEng}
                callback={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </EmailButtonComponent>
          );
        break;
      case 'Number':
        displayfield = displayField(field);
        if (displayfield) {
          controlArray.push(
            <NumberComponent key={"NumberComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
               callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </NumberComponent>
          )
        }
        field.Visible = displayfield;
        break;
      case "Text":
        controlArray.push(
          <TextComponent key={"TextComponent_" + field.parent.Id + "_" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}
            callbackStepIndex={(index) => this.props.callbackStepIndex(index)}>
          </TextComponent>
        );
        break;
      case 'MultiText':
        controlArray.push(
          <MultiTextComponent key={"MultiTextComponent" + field.Id}  field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
             callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </MultiTextComponent>
        );

        break;
      case 'Dropdown':
        controlArray.push(
          <DropdownComponent key={"DropdownComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} optionsFieldValue={this.props.optionsFieldValue} usedForFilter={this.props.usedForFilter}
             callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </DropdownComponent>
        );
        break;
      case 'GroupDropdown':
        controlArray.push(
          <GroupDropdownComponent key={"GroupDropdownComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} usedForFilter={this.props.usedForFilter}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </GroupDropdownComponent>
        )
        break;
    
      case 'CheckboxGroup':
      case 'Checkbox':
        controlArray.push(
          <CheckboxComponent key={"CheckboxComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} usedForFilter={this.props.usedForFilter} hint={hint}
             callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </CheckboxComponent>
        );
        break;

      case 'CheckboxWithTextbox':
        controlArray.push(
          <CheckboxWithTextboxComponent key={"CheckboxWithTextboxComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} usedForFilter={this.props.usedForFilter} 
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </CheckboxWithTextboxComponent>
        );
        break;

      case 'CheckboxWithInlineTextbox':
        controlArray.push(
          <CheckboxWithInlineTextboxComponent key={"CheckboxWithInlineTextboxComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} usedForFilter={this.props.usedForFilter} 
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </CheckboxWithInlineTextboxComponent>
        );
        break;
            case 'BXPCheckboxWithInlineTextbox':
        controlArray.push(
          <BXPCheckboxWithInlineTextboxComponent key={"BXPCheckboxWithInlineTextboxComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} usedForFilter={this.props.usedForFilter} 
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </BXPCheckboxWithInlineTextboxComponent>
        );
        break;
      case 'BXPCancelWithExit':
        controlArray.push(
          <BXPCancelWithExitComponent field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
         callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}
         callbackStepIndex={(index) => this.props.callbackStepIndex(index)}></BXPCancelWithExitComponent>
        )
        break;
      case 'CMAQuestion':
        controlArray.push(
          <CMAQuestionComponent key={"CMAQuestionComponent" + field.Id}
            field={this.props.field}
            editable={editable} title={title} 
            labelControlArray={labelControlArray}
            requiredField={requiredField} isEng={this.props.isEng}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}
          />
        );
        break;
      case 'SelectWithRichText':
          controlArray.push(
            <SelectWithRichTextComponent 
              key={"SelectWithRichTextComponent" + field.Id} 
              field={this.props.field} editable={editable} title={title} 
              labelControlArray={labelControlArray} 
              requiredField={requiredField}
              isEng={this.props.isEng}
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </SelectWithRichTextComponent>
          );
  
        break;
      case 'RadioButtonWithRichText':
        controlArray.push(
          <RadioWithRichTextComponent 
            key={"RadioWithRichTextComponent"  + field.parent.Id + "_" + field.Id} 
                field={this.props.field} editable={editable} title={title} 
                labelControlArray={labelForRadioRichText} 
                requiredField={requiredField}
                isEng={this.props.isEng}
                callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </RadioWithRichTextComponent>
        );
        break;
      case 'HTML':
      case 'Label':
        controlArray.push(
          <RichTextComponent 
            key={"RichTextComponent" + field.Id} field={this.props.field} 
            editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
            callbackStepIndex={(index, returnIndex)=>this.props.callbackStepIndex(index,returnIndex)}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </RichTextComponent>
        );

        break;
      case 'TechError':
        controlArray.push(
          <TechErrorComponent 
            key={"TechError_" + field.Id} 
            isEng={this.props.isEng}
            field={field}
            callback={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </TechErrorComponent>
        );

        break;
       case 'UnorderList':
         controlArray.push(
          <UnorderList 
            key={"TechError_" + field.Id} 
            isEng={this.props.isEng}
            field={field}
            callback={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </UnorderList>
        );
      case 'Table':
       controlArray.push(
          <TableComponent 
            key={"TechError_" + field.Id}
            field={this.props.field} 
            editable={editable} 
            title={title} 
            labelControlArray={labelControlArray} 
            requiredField={requiredField}
            isEng={this.props.isEng}
            callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </TableComponent>
        )
        break;
        case 'SummaryList':
          controlArray.push(
             <SummaryListComponent
              key={"TechError_" + field.Id}
               field={this.props.field}
               isEng={this.props.isEng}
               callback={(programContainer) => {this.props.callbackElement(programContainer)}}
               callbackStepIndex={(index) => {this.props.callbackStepIndex(index)}}>
             </SummaryListComponent>
           )
           break;
        case 'PagedSummaryList':
          controlArray.push(
             <PagedSummaryListComponent
              key={"PagedSummaryList_" + field.Id}
               field={this.props.field}
               isEng={this.props.isEng}
               callback={(programContainer) => {this.props.callbackElement(programContainer)}}
               callbackStepIndex={(index) => {this.props.callbackStepIndex(index)}}>
             </PagedSummaryListComponent>
           )
           break;
        case 'TableSummary':
          controlArray.push(
             <TableSummaryElementComponent 
              key={"TechError_" + field.Id}
               field={this.props.field} 
               isEng={this.props.isEng}
               callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
             </TableSummaryElementComponent>
           )
           break;
      case 'DataTable':
        controlArray.push(
            <DataTableComponent key={"TechError_" + field.Id} isEng={this.props.isEng}
              field={this.props.field}
              callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
            </DataTableComponent>
          )
          break;
      case 'ReportDataTable':
        // Cast field to any to access dynamic properties configured in form builder
        const reportField = field as any;
        controlArray.push(
            <ReportDataTable
              key={"ReportDataTable_" + field.Id}
              isEng={this.props.isEng}
              reports={field.Value || []}
              readOnly={field.ReadOnly || false}
              // New props for enhanced functionality
              allowUpload={reportField.AllowUpload || false}
              baseUrl={programContainer.APIBasePath}
              apiUrl={reportField.Api || reportField.ApiUrl}
              apiMethod={reportField.ApiMethod || 'PUT'}
              acceptFileType={reportField.AcceptFileType || '.xml'}
              validateXML={reportField.ValidateXML !== false}
              maxFileSize={reportField.MaxFileSize || 20}
              authRequired={reportField.AuthRequired || false}
              onNavigate={(sectionIndex) => {
                this.props.callbackStepIndex(sectionIndex);
              }}
              onFilesChange={(files) => {
                try {
                  const programContainer = getRootComponent(field);
                  // Store uploaded files in a designated field if needed
                  const reportsField = (field as any).findFieldByName?.('reports');
                  if (reportsField) {
                    if (!reportsField.Value) reportsField.Value = [];
                    files.forEach(f => {
                      if (!(f as any).hasError) {
                        reportsField.Value.push({
                          file: (f as any).file,
                          attachment: (f as any).attachment,
                          path: (f as any).path,
                          size: (f as any).size
                        });
                      }
                    });
                  }
                  this.props.callbackElement(programContainer);
                } catch (error) {
                  console.error('Error updating files:', error);
                }
              }}
              onRemove={(report) => {
                try {
                  const programContainer = getRootComponent(field);

                  programContainer.ListOfFormSections?.forEach((section) => {
                    section.ListOfFormSubSections?.forEach((subsection) => {
                      subsection.ListOfFormSectionElements?.forEach((element) => {
                        if (element.Datatype === 'File' && element.Value && Array.isArray(element.Value)) {
                          element.Value = element.Value.filter(file => {
                            const fileName = file.file?.name || file.attachmentFileName || file.path || '';
                            return !fileName.includes(report.nameOfReport);
                          });
                        }
                      });
                    });
                  });

                  this.props.callbackElement(programContainer);
                } catch (error) {
                  console.error('Error removing file:', error);
                }
              }}
            />
          )
          break;
      case 'TableMenu':
      controlArray.push(
          <TableMenuComponent 
            key={"TechError_" + field.Id}
            field={this.props.field} 
            isEng={this.props.isEng}
            callbackStepIndex={(index, returnIndex)=>this.props.callbackStepIndex(index,returnIndex)}
            callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </TableMenuComponent>
        )
        break;
      case 'AutoComplete':
        controlArray.push(
          <AutoCompleteComponent key={"TechError_" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
             callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </AutoCompleteComponent>
        )
        break;
      case 'Address':
        controlArray.push(
          <AddressComponent key={"AddressComponent_" + field.LoadBindName + "_"+ + field.Id}
            field={this.props.field} 
            editable={editable} title={title} 
            labelControlArray={labelControlArray} 
            requiredField={requiredField}
            isEng={this.props.isEng}  
            callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </AddressComponent>
        );
        break;
        case 'HiddenField':
          controlArray.push(
            <HiddenFieldComponent key={"HiddenField" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}  
            callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </HiddenFieldComponent>);
          break;
      case 'ConditionalLabel':
        if (this.props.field.FilterField != null) {
          let filterValue;
          let baseName;
          let bindName;
          let parts = this.props.field.FilterField.split('.');
          if (parts.length == 3) {
            baseName = parts[0] + '.' + parts[1];
            bindName = parts[2];
          }
          if (parts.length == 2) {
            baseName = parts[0];
            bindName = parts[1];
          }
          if (parts.length == 1) {
            baseName = '';
            bindName = parts[0];
          }
          let foundFilterField
          let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName);
          if (foundFilterFields != null && foundFilterFields.length > 0) {
            foundFilterField = foundFilterFields.at(0);
          }
          if (foundFilterField != null) {
            filterValue = foundFilterField.Value;

            if (filterValue == null || filterValue != null && (this.props.field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(this.props.field.FilterValue) == -1)) {
              displayfield = false;
            }
          } else {
              displayfield = true;
          }

          if (this.props.field.FilterCompareMethod != null && this.props.field.FilterCompareMethod != '') {
            if (foundFilterField != null && foundFilterField.Value != null && foundFilterField.Datatype == 'Date' && this.props.field.FilterCompareMethod == 'lessthan') {
              let otherDate = new Date(foundFilterField.Value);
              let today = new Date();
              var diff = Math.abs(today.getTime() - otherDate.getTime());
              var diffDays = Math.ceil(diff / (1000 * 3600 * 24));

              displayfield = diffDays >= Number.parseInt(this.props.field.FilterValue);
            }
          }
          if (displayfield) {
            controlArray.push(
              <div key={'Label_' + field.Id} >
                {labelControlArray}
              </div>);
          }
        }
        break;
      case 'Excel Template':
        controlArray.push(
          this.extractHeadersAndDownloadFile(field)
        )

      case 'Excel':
        this.fileField = field;
        let excelData
        if (this.props.topEntity != null) {
          excelData = this.props.topEntity[this.fileField.LoadBindName];
        }

        if (excelData && excelData.length > 0) {
          controlArray.push(<div>
            <DataTable key={'file_' + field.Id} value={excelData} id={'table_' + + field.Id} dataKey="id" emptyMessage={null} style={{ width: '100%' }}>
              <Column field="attachmentFileName" header="File Name" />
              <Column body={this.actionTemplate} style={{ textAlign: 'center', width: '6em' }} />
            </DataTable>
          </div>);
        }

        if (editable) {
          controlArray.push(<div key={"TechError_Excel_" + field.Id}>
            {/* @ts-ignore */}
            <FileUpload name="attachment[]" customUpload={true} maxFileSize={5000000} onRemove={this.onExcelRemove} auto={true} uploadHandler={this.excelUploader} />
          </div>);
        }

        { this.displayExcelTable(field) }

        //this.setState({activeObject:field});

        if (field.subSectionList) {
          let subSectionLs = field.subSectionList;
          subSectionLs.forEach(subSection => {
            if (editable || this.props.roleBased) {

              controlArray.push(
                <div key={"subSec_" + field.Id} title={field.TooltipENU} style={{ width: '100%' }}>
                  {/* {labelControlArray} */}
                  <div key={'fd_' + field.Id} title={field.TooltipENU} style={{ width: '100%' }}>
                    <ElementListComponent
                      key={'sub_list' + field.Id} {...this.props}
                      activeSubSection={subSection}
                      topEntity={this.props.topEntity}
                      user={this.props.user}
                      usedByDesigner={false}
                      editable={this.props.roleBased ? this.props.roleBasedEditable : editable}
                      callback={() => { this.props.callbackElement(subSection.parent.parent); }} />
                  </div>
                </div>

              )
            } else {
              controlArray.push(
                <div style={{ textAlign: 'center' }} key={"element_list_" + field.Id}>
                  <div style={{ width: '100%' }}>{field.ENUTitle}</div>this.props.user
                  <div style={{ width: '100%' }}> <ElementListComponent key={'sub_' + field.Id} {...this.props} usedByDesigner={false} activeSubSection={subSection} topEntity={this.props.topEntity}
                    user={this.props.user} editable={false} callback={() => this.props.callbackElement(subSection.parent.parent)} /></div>
                </div>)
            }
          });
        }


        break;
      case 'File':
        if(field.shareReferenceId){
          const root = getRootComponent(field)
          outer:
          for (const form of root.ListOfFormSections) {
              for (const subForm of form.ListOfFormSubSections) {
                  for (const ele of subForm.ListOfFormSectionElements) {
                      if(ele.sharable&& ele.LoadBindName===field.shareReferenceId){
                          field = ele;
                          break outer;
                      }

                  }

              }
          }
        }
        this.fileField = field
        let allowedFileTypes = field.FileUpload?.AllowedForUploadFileTypeList?.join(", ") ?? '';

        if (editable) {
          // Get custom upload title or use default
          const defaultTitle = this.props.isEng ? 'Choose a file' : 'Choisissez un fichier';
          const customTitle = this.props.isEng
            ? field.FileUpload?.UploadField?.title?.en
            : field.FileUpload?.UploadField?.title?.fr;
          // If customTitle is undefined/null, use default. If it's set (even empty string), use it.
          const uploadButtonTitle = customTitle !== undefined && customTitle !== null
            ? customTitle
            : defaultTitle;

          controlArray.push(
            <FileUploadComponent
              key={"file_upload_component_" + field.Id}
              field={field}
              lang={this.props.isEng? 'en' : 'fr'}
              title={uploadButtonTitle}
              setFieldValue={setFieldValue}
              callbackStepIndex={(index, returnIndex)=>this.props.callbackStepIndex(index,returnIndex)}
              appName={programContainer.CategoryId.toUpperCase()}
              callbackValidate ={(errors)=>this.props.callbackValidate(errors)}
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}
            />
          );
          // controlArray.push(
          //   <div>   
          //     <div>
          //       {/* @ts-ignore */}
          //       <Toast ref={(el) => this.toast = el} />
          //     </div>
          //     {/* @ts-ignore */}
          //     <FileUpload name="attachment[]" customUpload={true} auto={true} multiple={true}
          //       maxFileSize={Number(field.FileSize)}
          //       accept={allowedFileTypes}
          //       onRemove={this.fileUploader}
          //       onSelect={ (e) => {
          //         const files = e.files;
          //         for (let file of files) {
          //             if (!allowedFileTypes.includes(file.type)) {
          //                 this.toast.show({ severity: 'error', summary: 'Error', detail: `${file.name} is not an allowed file type.`, life: 3000 });
          //                 e.files = e.files.filter(f => f !== file);
          //             }
          //         }
          //       }}
          //       uploadHandler={this.fileUploader}
          //     />
          //   </div>
          // );
        } else {
          const data = field.Value?.map((file, index) => {
            let match = file.path?.match(/\/([^\/]+)$/, "$1");
            if (!match) {
              match = file.path?.match(/\\([^\\]+)$/, "$1");
            }
            let filename;
            if (isBxpForm(this.props.field)) {
              filename = file.file?.name;
            } else{
              filename = match?.[1];
            }
            return {
              id: index,
              attachmentFileName: filename,
              attachmentFileContent: file.attachment,
              fileSize: file?.size,
            }
          })
          // controlArray.push(
          //   <div>
          //     <DataTable key={'file_' + field.Id} value={data} id={'table_' + + field.Id} dataKey="id" emptyMessage={null} style={{ width: '100%' }}>
          //       <Column field="attachmentFileName" header="File Name" />
          //       <Column body={this.actionTemplate} style={{ textAlign: 'center', width: '6em' }} />
          //     </DataTable>
          //   </div>
          // )
          controlArray.push(
            <div key={'div_' + field.Datatype + '_' + field.Id}  className={programContainer.isHorizontalLayout ? 'pdf-row-column' : 'pdf-two-column'}>
              <div key={'div2_' + field.Datatype + '_' + field.Id}>{title}</div>
              <div key={'div3_' + field.Datatype + '_' + field.Id} className={classNames({ 'invalid-field--highlighted': (!field.Value || field.Value.length === 0) && requiredField})}>
                {data?.length && (
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {data.map((file) => (
                      <li
                        key={file.id}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          borderBottom: '1px solid #ccc',
                          padding: '0.25rem 0',
                        }}
                      >
                        
                        { !isBxpForm(this.props.field) && <span>{file.attachmentFileName}</span>}
                        { isBxpForm(this.props.field) && <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <span>{file.attachmentFileName}</span>
                            <span>{(file.fileSize / (1024 * 1024)).toFixed(2)} MB</span>
                        </span>}
                        { isBxpForm(this.props.field) ? null : this.actionTemplate(file, null)}
                        </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          );
        }
        break;
      //to add code for OCR. so far it is located in the API
      case 'Invoice':
        this.fileField = field;
        if (editable) {
          controlArray.push(<div key={"invoice_file_upload_" + field.Id}>
            {/* @ts-ignore */}
            <FileUpload name="attachment[]" customUpload={true} maxFileSize={5000000} onRemove={this.fileUploader} auto={true} uploadHandler={this.fileUploader} multiple={true} />
          </div>);
        }
        
        controlArray.push(
          <div key={"invoice_iframe_" + field.Id}>
            <iframe width="100%" src={this.attachment["attachmentFileContent"]} height="400"  ></iframe>
          </div>
        )

        this.displayInInvoiceTable(controlArray);
        break;

      case 'Download':
        controlArray.push(
          <div  key={"download_" + field.Id}>
            {labelControlArray}
            {this.generateDownloadButton(field)}
          </div>);
        break;

      case 'Image':
        field.Valid = true;
        controlArray.push(
          <div key={"image_" + field.Id} style={{ textAlign: 'center', }}>
            <img src={field.Value?.content} style={{ height: '400', width: '320px' }} alt={field.Value?.content}></img>
          </div>);
        break;
      case 'PdfButton':
        controlArray.push(
          <PdfButtonComponent key={"PdfButtonComponent" + field.Id}  isEng={this.props.isEng} 
          disabled={false}
          onClick={() => {
            this.props.callbackGeneratePdf?.(field);
          }}
          field={this.props.field} />
        );
        break;
      case 'Button':
      case 'CardButton':
        if (
          (field?.IsCancelButton || field?.IsSaveDraftButton) &&
          (field as any)?._renderedInline
        ) {
          break;
        }
        controlArray.push(
          <ButtonComponent key={"ButtonComponent" + field.Id} 
          field={this.props.field} 
          editable={editable}
          disabled={field.parent.parent.SectionReadonly === true}
          title={title} 
          labelControlArray={labelControlArray} 
          requiredField={requiredField}
          isEng={this.props.isEng} 
          callbackValidate={(errors, fromAPI)=>this.props.callbackValidate(errors, fromAPI)}
          callbackStepIndex={(index)=>this.props.callbackStepIndex(index)}  
          returnIndex={this.props.returnIndex}
            callback={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </ButtonComponent>);
          break;
      case 'DeleteSubsectionButton':
        controlArray.push(
          <DeleteSubsectionButtonComponent 
            isEng={this.props.isEng} 
            field={field} 
            callback={p => this.props.callbackElement(p)}
          />
        );
        break;
      case 'PublicSecureButton':
        controlArray.push(
          <PublicSecureButtonComponent key={"PublicSecureButtonComponent" + field.Id}
            field={this.props.field}
            editable={editable}
            title={title}
            labelControlArray={labelControlArray}
            requiredField={requiredField}
            isEng={this.props.isEng}
            callbackStepIndex={(index) => this.props.callbackStepIndex(index)}
            returnIndex={this.props.returnIndex}
            callback={(programContainer) => { this.props.callbackElement(programContainer) }}>
          </PublicSecureButtonComponent>
      
        );
        break;    
      case 'RepeatButton':
          controlArray.push(
            <RepeatButtonComponent key={"RepeatButtonComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng} callbackStepIndex={(index)=>this.props.callbackStepIndex(index)}  returnIndex={this.props.returnIndex}
              callback={(programContainer) => {this.props.callbackElement(programContainer)}}>
            </RepeatButtonComponent>);
            break;
          break;
      case 'GoogleLookUpAddress':
        controlArray.push(
          <GoogleLookUpAddressComponent
            key={"google_look_up_address_" + field.Id}
            field={this.props.field}
            editable={editable}
            title={title}
            labelControlArray={labelControlArray}
            requiredField={requiredField}
            isEng={this.props.isEng}
            callbackElement={(subSection: FormSubSections) => {
              this.props.callbackElement(subSection.parent.parent)
            }
            }></GoogleLookUpAddressComponent>
        )
      case 'GoogleMap':
        controlArray.push(
          <GoogleMapComponent
            key={"google_map_component_" + field.Id}
            field={this.props.field}
            labelControlArray={labelControlArray}
            isEng={this.props.isEng}
            callbackElement={(subSection: FormSubSections) => {
              this.props.callbackElement(subSection.parent.parent)
            }
            }></GoogleMapComponent>
        )
        break;
      case "CustomErrorAlerts":
        controlArray.push(<CustomErrorAlertsComponent key={"customer_error_alert_" + field.Id} field={this.props.field} isEng={this.props.isEng}
          callbackElement={(programContainer) => { this.props.callbackElement(programContainer) }}></CustomErrorAlertsComponent>);
        break;
      case "DriverLicense":
        try {
          if (field.Script) {
              eval(field.Script)();
          }
        } catch (error) {
            console.error("Error executing field.Script:", error);
        }
        displayfield = displayField(field);
        if (displayfield) {
          controlArray.push(
            <DriverLicenseComponent field={this.props.field} key={"driver_license_" + field.Id} editable={editable} title={title}
              labelControlArray={labelControlArray} requiredField={requiredField} isEng={this.props.isEng}
              callbackElement={(programContainer ) => {this.props.callbackElement(programContainer)}}/>
          )
        }
        field.Visible = displayfield;
        break;
      case "RegistrantIdentificationNumber":
        try {
          if (field.Script) {
              eval(field.Script)();
          }
        } catch (error) {
            console.error("Error executing field.Script:", error);
        }
        displayfield = displayField(field);
        if (displayfield) {
          controlArray.push(
            <RegistrantIdenticationNumberComponent key={"registrant_id_num_" + field.Id} field={this.props.field} editable={editable} title={title}
              labelControlArray={labelControlArray} requiredField={requiredField} isEng={this.props.isEng}
              callbackElement={(programContainer ) => {this.props.callbackElement(programContainer)}}/>
          )
        }
        field.Visible = displayfield;
        break;
      case "CheckPlateAndRenderImage":
        displayfield = displayField(field);
        if (displayfield) {
          controlArray.push(
            <CheckPlateAndRenderImageComponent field={this.props.field} key={"check_plate_render_image_" + field.Id}
              labelControlArray={labelControlArray} requiredField={requiredField} isEng={this.props.isEng}
              callbackStepIndex={(index, returnIndex)=>this.props.callbackStepIndex(index,returnIndex)}
              callbackElement={(programContainer ) => {this.props.callbackElement(programContainer)}}
              callbackValidate={this.props.callbackValidate}/>
          )
        }
        field.Visible = displayfield;
        break;
      case "Feedback":
        controlArray.push(
          <FeedbackComponent programContainer={getRootComponent(field)} isEng={this.props.isEng} field={this.props.field}></FeedbackComponent>
        )
        break;
      case "LicensePlate":
        controlArray.push(
          <LicensePlateComponent field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
         callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}></LicensePlateComponent>
        )
          break;
      case "HealthCard":
        controlArray.push(
          <HealthCardComponent field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
         callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}></HealthCardComponent>
        )
            break;
      case "InformationAlert":
        controlArray.push(<InformationalAlertComponent  isEng={this.props.isEng} field={field}/>)
        break;
      case "WarningAlert":
        controlArray.push(
          <FadeableWrapper key={`fadeable_warning_${field.Id}`} field={field} onFadeComplete={() => this.props.callbackElement(getRootComponent(field))}>
            <WarningAlertComponent isEng={this.props.isEng} Visible={field.Visible} bodyMsg={reactElement} title={this.props.isEng? field.MessageTitle:field.MessageTitleFRA} />
          </FadeableWrapper>
        );
        break;
      case "ErrorAlert":
        controlArray.push(
          <FadeableWrapper key={`fadeable_error_${field.Id}`} field={field} onFadeComplete={() => this.props.callbackElement(getRootComponent(field))}>
            <ErrorAlertComponent field={field} isEng={this.props.isEng} Visible={field.Visible} bodyMsg={reactElement} title={this.props.isEng? field.MessageTitle:field.MessageTitleFRA} />
          </FadeableWrapper>
        );
        break;
      case "SuccessAlert":
        controlArray.push(
          <FadeableWrapper key={`fadeable_success_${field.Id}`} field={field} onFadeComplete={() => this.props.callbackElement(getRootComponent(field))}>
            <SuccessAlertComponent field={field} isEng={this.props.isEng} Visible={field.Visible} bodyMsg={reactElement} title={this.props.isEng? field.MessageTitle:field.MessageTitleFRA} />
          </FadeableWrapper>
        );
        break;
      case 'StarRating':
        // controlArray.push(<StarRating field={field} isEng={this.props.isEng} title={this.props.isEng? field.MessageTitle:field.MessageTitleFRA} callbackElement = {p => this.props.callbackElement(p)} />);
        controlArray.push(<StartRatingAccessibilityComponent field={field} isEng={this.props.isEng} title={this.props.isEng? field.MessageTitle:field.MessageTitleFRA} callbackElement = {p => this.props.callbackElement(p)} />);
        break;
      case 'SignaturePad':
         controlArray.push(<SignaturePadComponent   />);
        break;
      case 'SearchAutocomplete':
        controlArray.push(<SearchAutocompleteComponent key={"SearchAutocompleteComponent" + field.Id} field={field} isEng={this.props.isEng} editable={editable} title={title} requiredField={requiredField}
        callbackElement={(programContainer: ProgramContainer) => { this.props.callbackElement(programContainer); } } labelControlArray={undefined} />);
        break;
      case 'SearchSingleItemFromApi':
        controlArray.push(<SearchSingleItemFromApiComponent
          key={"SearchSingleItemFromApi" + field.Id} field={field} isEng={this.props.isEng} requiredField={requiredField}
          labelControlArray={labelControlArray}
          callbackStepIndex={(index, returnIndex)=>this.props.callbackStepIndex(index,returnIndex)}
          callbackElement={(programContainer: ProgramContainer) => { this.props.callbackElement(programContainer); }} />);
        break;
      case 'TileSelection':
        controlArray.push(
          <TileSelectionComponent
            key={"TileSelection_" + field.Id}
            baseUrl={programContainer.APIBasePath}
            apiUrl={field.TileSelection?.apiUrl || ''}
            responseKey={field.TileSelection?.responseKey || 'services'}
            idField={field.TileSelection?.idField || 'id'}
            nameField={field.TileSelection?.nameField || 'name'}
            title={this.props.isEng ? field.ENUTitle : field.FRATitle}
            authToken={SessionStorageService.getBPSToken()}
            isEng={this.props.isEng}
            autoSelectSingle={field.TileSelection?.autoSelectSingle !== false}
            onSelect={(item) => {
              field.Value = item;
              this.props.callbackElement(getRootComponent(field));
              if (field.TileSelection?.nextSection) {
                this.props.callbackStepIndex(field.TileSelection.nextSection - 1);
              } else if (field.TileSelection?.redirectUrl) {
                const url = field.TileSelection.redirectUrl.replace('{name}', encodeURIComponent(item.name)).replace('{id}', encodeURIComponent(String(item.id)));
                window.location.href = url;
              }
            }}
            onAutoSelect={(item) => {
              field.Value = item;
              this.props.callbackElement(getRootComponent(field));
              if (field.TileSelection?.nextSection) {
                this.props.callbackStepIndex(field.TileSelection.nextSection - 1);
              } else if (field.TileSelection?.redirectUrl) {
                const url = field.TileSelection.redirectUrl.replace('{name}', encodeURIComponent(item.name)).replace('{id}', encodeURIComponent(String(item.id)));
                window.location.href = url;
              }
            }}
          />
        );
        break;
      case 'Accordions':
        controlArray.push(
          <AccordionsComponent
            field={field} 
            contents={this.props.isEng ? field.accordions?.accordions : field.accordionsFRA?.accordions}
            lang={this.props.isEng ? 'en' : 'fr'} 
            expandAll={!!field.accordions?.expandAll}
            callbackStepIndex={(index, returnIndex)=>this.props.callbackStepIndex(index,returnIndex)}
            callBack={p => this.props.callbackElement(p)}/>
        );
        break;
      case 'DynamicAccordionForm':
        controlArray.push(
          <DynamicAccordionFormComponent
            key={`DynamicAccordionForm_${field.Id}`}
            field={this.props.field}
            isEng={this.props.isEng}
            editable={editable}
            user={this.props.user}
            callbackStepIndex={this.props.callbackStepIndex}
            callback={this.props.callbackElement}
          />
        );
        break;
      case 'TransId':
        const root = getRootComponent(field);
        controlArray.push(
          <TransactionIdComponent 
            field={field} 
            transactionId={field.Value} 
            appId={root.CategoryId} 
            lang={this.props.isEng? 'en' : 'fr'} 
            callback={p => this.props.callbackElement(p)}
          />
        )
        break;
      case 'RecaptchaButton':
        controlArray.push(
          <SubmitButtonComponent
            field={field}
            isEng={this.props.isEng}
            callback={(programContainer) => {this.props.callbackElement(programContainer)}}
            callbackValidate={(errors) => this.props.callbackValidate(errors)}
            callbackStepIndex={(index, returnIndex) => this.props.callbackStepIndex(index, returnIndex)}
          />
        )
        break;
      case "InquireAndRedirect":
        displayfield = displayField(field);
        if (displayfield) {
          controlArray.push(
            <InquireAndRedirectComponent key={"InquireAndRedirectComponent" + field.Id} 
              field={this.props.field} 
              title={title} 
              isEng={this.props.isEng} 
              callbackStepIndex={(index)=>this.props.callbackStepIndex(index)}  
              returnIndex={this.props.returnIndex}
              callback={(programContainer) => {this.props.callbackElement(programContainer)}}>
            </InquireAndRedirectComponent>
          )
        }
        field.Visible = displayfield;
        break;
      case "OrderConfirmation":
        displayfield = displayField(field);
        if (displayfield) {
          controlArray.push(
            <OrderConfirmationComponent field={this.props.field}
              programContainer={getRootComponent(field)}
              isEng={this.props.isEng}
              callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}/>
          )
        }
        field.Visible = displayfield;
        break;
      case "IncidentReportConfirmation":
        // Always show IncidentReportConfirmation on confirmation pages
        field.Visible = true;
        field.InvisibleByDefault = false;
        controlArray.push(
          <IncidentReportConfirmationComponent field={this.props.field}
            programContainer={getRootComponent(field)}
            isEng={this.props.isEng}
            callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}/>
        )
        break;
      case "OrderInfoBreakdown":
        displayfield = displayField(field);
        if (displayfield) {
          controlArray.push(
            <OrderInfoBreakdownComponent field={this.props.field}
              isEng={this.props.isEng}/>
          )
        }
        field.Visible = displayfield;
        break;
      case "OrderPriceBreakdown":
        displayfield = displayField(field);
        if (displayfield) {
          controlArray.push(
            <OrderPriceBreakdownComponent field={this.props.field}
              isEng={this.props.isEng}/>
          )
        }
        field.Visible = displayfield;
        break;
      case "OrderBreakdown":
        displayfield = displayField(field);
        if (displayfield) {
          controlArray.push(
            <OrderBreakdownComponent field={this.props.field}
              isEng={this.props.isEng}/>
          )
        }
        field.Visible = displayfield;
        break;

        case "Modal":
          controlArray.push(
            <FieldModalComponent field={this.props.field}
              isEng={this.props.isEng}
              programContainer={getRootComponent(field)}
              callback={(programContainer) => { this.props.callbackElement(programContainer) }}
            />
          );
          break;

      // case 'CardButton': 
      //   controlArray.push(
      //     <CardButtonComponent key={"CardButtonComponent" + field.Id} 
      //       field={this.props.field} 
      //       isEng={this.props.isEng}
      //       callbackStepIndex={(index)=>this.props.callbackStepIndex(index)}  
      //       callback={(programContainer) => {this.props.callbackElement(programContainer)}}
      //     />
      //   );
      //   break;
      // case 'QRCode': 
      //   //const env = process.env.ENV ?? 'dev';
      //   const root = getRootComponent(this.props.field);
      //   const url = EnvBaseUrl.prod + '/' + root.CategoryId;
      //   controlArray.push(<QRCodeComponent value={url} size={100} />);
      //   break;
      // case 'Callout':
      //   controlArray.push(
      //     <
      //   )
      // default:
      //   let foundArray = ['CheckboxGroup', 'SectionGroup'];
      //   if (foundArray.indexOf(field.Datatype) < 0) {
      //     controlArray.push(
      //       <div key={'fd_' + field.Id} title={'Id:' + field.Id}>
      //         {labelControlArray}
      //         <div>Unknown Datatype: {field.Datatype}</div>
      //       </div>
      //     );
      //   }
    }
    // field.Visible = displayfield;

    if (field.hintExpansionTitle
        && field.Visible
        && !['CMAQuestion', 'DriverLicense', 'RegistrantIdentificationNumber', 'Address','File'].includes(field.Datatype)) {
      const display = displayField(field);
      if (!display) return controlArray;
      const calloutMaxWidth = calloutWidths[field?.callOutSize] || '48rem';
      const bobyMessage = htmlToReactParser.parse(this.props.isEng ? (field.hintExpansionBelowElementLabel ? field.hintExpansionContent : field.callOutBoxBody) : (field.hintExpansionBelowElementLabel ? field.hintExpansionContentFRA : field.callOutBoxBodyFRA));
     if(this.props.editable){
           controlArray.push(
        <div style={{maxWidth: calloutMaxWidth, marginTop: `${field.Datatype === 'CheckGroup' ? '1rem': field.Datatype != 'RadioButton'?  '-3%' : '0'}`}}>
          {!field.hintExpansionBelowElementLabel &&
          <HintExpansionComponent
            isEng={true}
            calloutType={field.callOutBoxType}
            Visible={field.Visible}
            bodyMsg={bobyMessage}
            title={this.props.isEng? field.callOutBoxTitle:field.callOutBoxTitleFRA}
            hintExpansionTitle={this.props.isEng? field.hintExpansionTitle:field.hintExpansionTitleFRA}
            field={field}
            callbackStepIndex={this.props.callbackStepIndex}
          ></HintExpansionComponent>}
        </div>
      )
      }
   
    } else if (field.callOutBoxType && editable && !field.hintExpansionTitle) {
      const display = displayField(field);
      if (!display) return controlArray;

      const reactElement = htmlToReactParser.parse(this.props.isEng?  field.callOutBoxBody:field.callOutBoxBodyFRA);

      const callOutBoxTitle = this.props.isEng? field.callOutBoxTitle:field.callOutBoxTitleFRA;
      const calloutMaxWidth = calloutWidths[field?.callOutSize] || '48rem';

      let calloutNode: React.ReactNode = null;
      switch (field.callOutBoxType) {
        case 'general':
          calloutNode = (
            <div style={{maxWidth: calloutMaxWidth}}>
              <GeneralCalloutComponent
                isEng={this.props.isEng}
                bodyMsg={reactElement}
                title={callOutBoxTitle}
              ></GeneralCalloutComponent>
            </div>);
          break;
        case 'informational':
          calloutNode = (
            <div style={{maxWidth: calloutMaxWidth}}>
              <InformationalAlertComponent isEng={this.props.isEng} field={field}/>
            </div>);
          break;
        case 'richText':
          calloutNode = (
            <InformationalRichTextComponent
              isEng={this.props.isEng}
              bodyMsg={this.props.isEng ? field.callOutBoxBody : field.callOutBoxBodyFRA}
              title={callOutBoxTitle}
              field={field}
              callbackStepIndex={this.props.callbackStepIndex}
            />);
          break;
        case 'warning':
          calloutNode = (
            <div style={{maxWidth: calloutMaxWidth}}>
              <WarningAlertComponent
                isEng={this.props.isEng}
                bodyMsg={reactElement}
                title={callOutBoxTitle}
                Visible={field.Visible}
              ></WarningAlertComponent>
            </div>);
          break;
        case 'success':
          calloutNode = (
            <div style={{maxWidth: calloutMaxWidth}}>
              <SuccessAlertComponent
                isEng={this.props.isEng}
                bodyMsg={reactElement}
                title={callOutBoxTitle}
                Visible={field.Visible}
                field={field}
              ></SuccessAlertComponent>
            </div>);
          break;
        case 'error':
          calloutNode = (
            <div style={{maxWidth: calloutMaxWidth}}>
              <ErrorAlertComponent
                isEng={this.props.isEng}
                bodyMsg={reactElement}
                title={callOutBoxTitle}
                Visible={field.Visible}
                field={field}
              ></ErrorAlertComponent>
            </div>);
          break;
      }
      if (calloutNode) {
        controlArray.push(
          <FadeableWrapper key={`fadeable_callout_${field.Id}`} field={field} onFadeComplete={() => this.props.callbackElement(getRootComponent(field))}>
            {calloutNode}
          </FadeableWrapper>
        );
      }
    }



    return controlArray;
  }


  actionTemplate(rowData, column) {
    // if(rowData["id"]==null) return null;
    return <div>
      <Button type="button" icon="pi pi-download" className="p-button-success" aria-label={`Download ${rowData['attachmentFileName']}`}
        onClick={async () => {
          let a = document.createElement("a"); //Create <a>    
          if (rowData['attachmentFileContent'] != null && rowData['attachmentFileContent'].toString().startsWith("data:")) {
            a.href = rowData['attachmentFileContent'];
            a.download = rowData['attachmentFileName'];
            a.click();
          } else {
            let response = await axios.get(URLUtils.concatUrls("data/program/fileRetrieval/" + rowData["id"]), { withCredentials: true });
            let data = response.data;
            a.href = "data:" + rowData["attachmentFileType"] + ";base64," + data;
            a.download = rowData['attachmentFileName'];
            a.click();
          }
        }
        }></Button>
    </div>;
  }

  fileField: FormSectionElements;
  attachment = {};

  excelUploader = async (files) => {
    this.fileUploaded = true;

    let worksheetNames = [];
    let attachment = [];

    for (const file of files.files) {
      const reader = new FileReader();

      const readFile = () => {
        return new Promise<void>((resolve, reject) => {
          reader.onload = function (e) {
            const binarystr = e.target.result;
            const wb = XLSX.read(binarystr, { type: 'binary', cellDates: true });
            wb.SheetNames.forEach(function (sheetName) {
              worksheetNames.push(sheetName);
              var XL_row_object = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { header: 1, dateNF: "dd/mm/yyyy" });
              attachment.push(XL_row_object);
            });
            resolve();
          };
          reader.onerror = function (e) {
            reject(e);
          };
        });
      };

      reader.readAsBinaryString(file);
      await readFile();
    }

    this.attachmentContent = attachment;
    this.setState({ attContent: attachment });
    this.worksheetNames = worksheetNames;
  };

  onExcelRemove = () => {
    const root = getRootComponent(this.props.field);
    let activeObject = parseJson(stringifyJson(this.props.field, root.CategoryId), root.CategoryId);

    activeObject.Value = null;

    // this.setState({ activeObject: activeObject }, () => {

    // });
  }

  fileUploader = (e) => {
    // let entity = [];
    this.fileField.Value = [];
    e.files?.forEach(element => {
      var reader = new FileReader();
      reader.onload = () => {
        let attachment = {};
        attachment["attachmentFileName"] = element.name;
        attachment['attachmentFileType'] = element.type;
        attachment['attachmentFileContent'] = reader.result;
        // let foundElement = entity.filter(p => p.attachmentFileName == element.name);
        // if (foundElement == null || foundElement.length == 0) {
        this.fileField.Value.push(attachment)

        // entity.push(this.fileField.LoadBindName, this.attachment);
        // let api = "data/admin/ocr";
        // axios.post(URLUtils.concatUrls(api), this.attachment, { withCredentials: true }).then((result) => {

        //   this.parseResult(result.data);
        // })
      }

      reader.readAsDataURL(element);
    });
    console.log(e);
    //  this.fileField.Value=e.files;
    // e.files = null;
    // this.props.topEntity[this.fileField.LoadBindName] = entity;
  };


  invoiceDetailItems = [];
  parseResult = (result) => {
    //look for item detail table
    let resultArray = result.split(/\r?\n|\r|\n/g);

    let numberIndexArray = [];
    for (let i = 0; i < resultArray.length; i++) {
      if (!Number.isNaN(+resultArray[i].replace('$', ''))) {

        numberIndexArray.push(i)
      }
    }

    let j;
    for (let i = 0; i < numberIndexArray.length; i++) {
      //to detect if the i is consective
      //if(numberIndexArray[i]==numberIndexArray[i+1]-1 && numberIndexArray[i]==numberIndexArray[i+2]-2){
      if (numberIndexArray[i] == numberIndexArray[i + 1] - 1) {
        j = i;
        break;
      }
    }

    let startLineNumer = numberIndexArray[j];
    //assume 3 columns for number


    for (let i = 0; i < numberIndexArray.length; i += 4) {
      let description = resultArray[startLineNumer + i - 1];
      let qty = resultArray[startLineNumer + i];
      let unitPrice = resultArray[startLineNumer + i + 1];
      let amount = resultArray[startLineNumer + i + 2];
      this.invoiceDetailItems.push({
        description: description,
        qty: qty,
        unitPrice: unitPrice,
        amount: amount
      })
    }

  }

  displayInInvoiceTable = (controlArray) => {
    let columns = [];

    if (this.invoiceDetailItems.length > 0) {
      columns.push(<Column field='description' header='Description' ></Column>);
      columns.push(<Column field='qty' header='Qty' ></Column>);
      columns.push(<Column field='unitPrice' header='Unit Price' ></Column>);
      columns.push(<Column field='amount' header='Amount'></Column>);
      controlArray.push(
        <div key='fdTable_div_invoice' style={{ width: '100%' }}>
          <DataTable showGridlines key={'BtnAdd_invoice'} value={this.invoiceDetailItems} id={'table_invoice'}
            dataKey="id" emptyMessage={null} style={{ width: '100%' }}>
            {columns}
          </DataTable>
        </div>)
    }
  }

  displayExcelTable = (field) => {
    const attachments = this.state.attContent;
    //console.log(attachments);

    if (attachments.length > 0) {
      attachments.forEach((ws) => {
        let wsHeader = ws[0]
        ws = this.convertoJson(wsHeader, ws);
        this.populateFormControlsForExcel(wsHeader, field, ws);
      })
    } else {
      return null;
    }
  }

  populateFormControlsForExcel(headers: [], excelField: FormSectionElements, data) {
    const subSection = new FormSubSections();
    subSection.parent = excelField;
    subSection.Sequence = 1;
    subSection.ListOfFormSectionElements = [];

    if (excelField.Datatype !== 'Excel Template') {
      headers.forEach((header, index) => {
        const ele = new FormSectionElements();

        if (data[0][header] instanceof Date) {
          ele.Datatype = 'Date';
        } else {
          ele.Datatype = 'Text';
        }
        ele.ENUTitle = header;
        ele.Editable = 'Y';
        ele.LoadBindName = header;
        ele.Sequence = index;
        ele.parent = subSection;
        subSection.ListOfFormSectionElements.push(ele);
      })

      excelField.subSectionList = [];
      excelField.subSectionList.push(subSection);

    }
    //first time read from excel, second time render from element list
    if (this.fileUploaded) {
      excelField.Value = data;

      this.fileUploaded = false;
    }
  }


  convertoJson = (headers, data) => {
    let rows = [];

    data.forEach((row, rindex) => {
      let rowData = {};
      //ignore headers
      if (rindex != 0) {
        row.forEach((el, index) => {
          rowData[headers[index]] = el;
        })
        rows.push(rowData);
      }
    })

    if (this.props.field.HasSummaryRow == 'Y')
      rows = this.calcTotal(rows)

    //console.log(rows);

    return rows;
  }

  calcTotal(rows) {
    let totals = {};

    if (!rows || rows.length == 0) {
      return null;
    }

    totals = rows.reduce((acc, invoice) => {
      Object.entries(invoice).forEach(([key, value]) => {
        if (typeof value === 'number') {
          if (acc.hasOwnProperty(key)) {
            acc[key] += value;
          } else {
            acc[key] = value;
          }
        }
      });
      return acc;
    }, {});

    const keys = Object.keys(rows[0]);
    if (keys.length > 0) {
      const firstKey = keys[0];
      totals[firstKey] = this.TOTAL_COLUMN_VALUE;
    }

    rows.push(totals);

    return rows
  }

  generateDownloadButton(field) {
    if (!field.Value || !field.Value.content) {
      return null;
    }

    return <div style={{ marginBottom: '5%' }}>
      <p>{field.Value.fileName}</p>
      <Button type="button" icon="pi pi-download" className="p-button-success"
        onClick={async () => {
          let a = document.createElement("a"); //Create <a>    
          if (field.Value && field.Value.content) {
            a.href = field.Value.content;
            a.download = field.Value.fileName;
            a.click();
          }
        }
        }>Download Template</Button>
    </div>;
  }

  ConvertToCSV(objArray, headerList) {
    let array = objArray;
    let str = '';
    let row = '';

    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = (i + 1) + '';
      for (let index in headerList) {
        let head = headerList[index];

        line += ',' + array[i][head];
      }
      str += line + '\r\n';
    }
    return str;
  }

  downloadToCSV(data, filename, headers) {
    let csvData = this.ConvertToCSV(data, headers);

    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  extractHeadersAndDownloadFile = (field) => {
    let headers = [];
    let data = [];
    if (field) {
      field.subSectionList[0].ListOfFormSectionElements.forEach(column => {
        headers.push(column.ENUTitle);
      })
    }


    return <div style={{ marginBottom: "5%" }}>
      <Button
        onClick={async () => {
          this.downloadToCSV(data, field.ENUTitle, headers);
        }}>Download {field.ENUTitle}</Button>
    </div>
  }

 
}
